import "../App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useState } from "react";
import EducationDetail from "./EducationDetail";
import Sidebar from "./Sidebar";
import HashLoader from "react-spinners/HashLoader";
import AccordionFilter from "./AccordionFilter";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons";

export default function LandingPage(props) {
  const {
    sidebarData,
    currentJamaatName,
    sort,
    allJamaatIds,
    currentData,
    utMemeber,
    handleSort,
    EduStatus,
    setageLimit,
    downloadRecord,
    handleJamaatChange,
    handleRequest,
    jamaatId,
    handleDataRefresh,
    handleSubmitAge,
  } = props;
  const [color, setColor] = useState("#00336D");
  const [ageLimit, setAgeLimit] = useState({ lowerAge: 3, higherAge: 27 });

  const onLoad = {
    height: "100vh",
  };

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const today = new Date();
  const month = monthNames[today.getMonth()];
  const currentDate = month + ", " + today.getFullYear();

  const handleAgeChnage = (e) => {
    let newAge = e.target.value;
    if (newAge < 3) newAge = 3;
    if (newAge > 27) newAge = 27;
    setAgeLimit({
      ...ageLimit,
      [e.target.name]: newAge,
    });
  };

  return (
    <>
      <Row
        style={{
          backgroundColor: "#E5E5E5",
          margin: "0px",
          ...(!sidebarData ? onLoad : ""),
        }}
      >
        <Col
          className="sidebarMedia mt-1"
          xs={3}
          style={{ backgroundColor: "#fff" }}
        >
          {sidebarData ? (
            <>
              <div className="m-4 primary-bg">
                <div className="primary-label">Students in My Mauze</div>
                <div
                  className="mb-1 mt-2"
                  style={{ color: "white", fontSize: "0.85em" }}
                >
                  <strong>Age Group</strong>
                </div>
                <div className=" d-flex mb-1">
                  <input
                    type="number"
                    name="lowerAge"
                    value={ageLimit.lowerAge}
                    className="form-control input-get"
                    aria-label="Text input with checkbox"
                    onChange={handleAgeChnage}
                  />
                  <input
                    type="number"
                    name="higherAge"
                    value={ageLimit.higherAge}
                    className="form-control input-get"
                    aria-label="Text input with checkbox"
                    onChange={handleAgeChnage}
                  />
                  <button
                    type="button"
                    className="btn btn-secondary btn-get"
                    onClick={() =>
                      handleSubmitAge(ageLimit.lowerAge, ageLimit.higherAge)
                    }
                  >
                    Get data
                  </button>
                </div>

                <div className="dropdown mb-1">
                  <button
                    className="btn btn-primary btn-block dropdown-toggle"
                    type="button"
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <strong>{currentJamaatName}</strong>
                  </button>
                  <div
                    className="dropdown-menu"
                    aria-labelledby="dropdownMenuButton"
                  >
                    {allJamaatIds?.map((item) => (
                      <a
                        className="dropdown-item"
                        key={item.jamaat_id}
                        onClick={() =>
                          handleJamaatChange(item.jamaat_id, item.jamaat)
                        }
                      >
                        {item.jamaat}
                      </a>
                    ))}
                  </div>
                </div>
                <Sidebar
                  sidebarData={sidebarData.Total_Student}
                  handleRequest={handleRequest}
                  EduStatus={EduStatus}
                />
                <Sidebar
                  sidebarData={sidebarData.Male_Student}
                  handleRequest={handleRequest}
                  EduStatus={EduStatus}
                />
                <Sidebar
                  sidebarData={sidebarData.Female_Student}
                  handleRequest={handleRequest}
                  EduStatus={EduStatus}
                />
                <Sidebar
                  sidebarData={sidebarData.Migrated_In}
                  handleRequest={handleRequest}
                  EduStatus={EduStatus}
                  theme={{
                    bg: "#ededed",
                    color: "#57774c",
                    activeBg: "#57774c",
                    activeColor: "#ededed",
                  }}
                  addClass="mt-3"
                />
              </div>

              <div className="m-4">
                <div className="sidebar-content">
                  <strong>Raza Status:</strong>
                </div>
                <Sidebar
                  sidebarData={sidebarData.Raza_Status}
                  handleRequest={handleRequest}
                  EduStatus={EduStatus}
                />
              </div>

              <div
                className={`m-4 ${
                  Array.isArray(sidebarData.Stream) &&
                  sidebarData.Stream.length > 0
                    ? ""
                    : "d-none"
                }`}
              >
                <div className="sidebar-content">
                  <strong>Streams / Marhala:</strong>
                </div>
                <Sidebar
                  sidebarData={sidebarData.Stream}
                  handleRequest={handleRequest}
                  EduStatus={EduStatus}
                />
              </div>

              <div className="m-4">
                <div className="sidebar-content">
                  <strong>Other Categories:</strong>
                </div>
                <Sidebar
                  sidebarData={sidebarData.main_menu}
                  handleRequest={handleRequest}
                  EduStatus={EduStatus}
                />
              </div>

              <div className="m-4">
                <a
                  className="btn-download"
                  style={{ position: "static" }}
                  href={`https://talabulilm.org/profile/csvdownload.php?jamaat=${jamaatId}&minAge=${ageLimit.lowerAge}&maxAge=${ageLimit.higherAge}`}
                  target="_blank"
                >
                  {" "}
                  Download All Records
                </a>
              </div>
            </>
          ) : (
            <div className="loader-content">
              <HashLoader color={color} size={30} />
            </div>
          )}
        </Col>
        {sidebarData ? (
          <AccordionFilter
            sidebarData={sidebarData}
            handleRequest={handleRequest}
            EduStatus={EduStatus}
            ageLimit={ageLimit}
            handleAgeChnage={handleAgeChnage}
            handleSubmitAge={handleSubmitAge}
            currentJamaatName={currentJamaatName}
            allJamaatIds={allJamaatIds}
            handleJamaatChange={handleJamaatChange}
          />
        ) : (
          <div className="loader-content text-center mt-5 d-block d-sm-none">
            <HashLoader size={30} />
          </div>
        )}

        <Col xs={12} lg={9} className="main-content mt-1">
          <h3 className="page-title">
            Showing results for "{EduStatus}" as of {currentDate}
          </h3>
          <div className="explaination-box d-none d-sm-block show-less">
            <p>
              <strong>Note:</strong> All the data displayed on this page is
              fetched from the Araiz mumineen send to Hadrat Aaliyah for their
              Education, and through the Educational Profile where mumineen
              update their data. Any discrepancy in this data can be resolved
              through www.talabulilm.org/profile. Mumineen will be able to edit
              or remove any incorrect data. Currently, Amil saheb will not be
              able to delete any incorrect entries. But, Amil saheb can add
              data/survey of students whose data is incomplete through the
              Education Survey tab
            </p>
            {(EduStatus === "Migrated In for current education" ||
              EduStatus === "Migrated Out for current education") && (
              <p>
                The data displayed on this page consists of Student's who have
                migrated from other cities to the Cluster that your mauze
                belongs to. It cannot be determined that which insitute belongs
                to which Mohalla or Mauze, therefore Talabulilm has created
                Clusters of citites that are geographically very close to the
                insitutes. And all these insitutes are tagged with its
                respective clusters. The results currently displayed will be
                shown to all mawaze in your Cluster
              </p>
            )}
          </div>
          <a
            className="btn-download"
            href={`https://talabulilm.org/profile/csvdownload.php${downloadRecord}`}
            target="_blank"
          >
            {" "}
            Download
          </a>
          <div>
            <span className="label">Sort By: </span>
            <button
              type="button"
              className={`btn  ${
                sort.field === "age" ? "btn-sort-active" : "btn-sort"
              }`}
              onClick={() => handleSort("age")}
            >
              Sort By Age{" "}
              {sort.direction === "asc" && sort.field === "age" ? (
                <FontAwesomeIcon icon={faArrowDown} />
              ) : sort.direction === "desc" && sort.field === "age" ? (
                <FontAwesomeIcon icon={faArrowUp} />
              ) : (
                ""
              )}
            </button>
            <button
              type="button"
              className={`btn ${
                sort.field === "name" ? "btn-sort-active" : "btn-sort"
              }`}
              onClick={() => handleSort("name")}
            >
              Sort By Name{" "}
              {sort.direction === "asc" && sort.field === "name" ? (
                <FontAwesomeIcon icon={faArrowDown} />
              ) : sort.direction === "desc" && sort.field === "name" ? (
                <FontAwesomeIcon icon={faArrowUp} />
              ) : (
                ""
              )}{" "}
            </button>
            <button
              type="button"
              className={`btn ${
                sort.field === "gender" ? "btn-sort-active" : "btn-sort"
              }`}
              onClick={() => handleSort("gender")}
            >
              Sort By Gender{" "}
              {sort.direction === "asc" && sort.field === "gender" ? (
                <FontAwesomeIcon icon={faArrowDown} />
              ) : sort.direction === "desc" && sort.field === "gender" ? (
                <FontAwesomeIcon icon={faArrowUp} />
              ) : (
                ""
              )}{" "}
            </button>
            <button
              type="button"
              className={`btn ${
                sort.field === "current_edu_course"
                  ? "btn-sort-active"
                  : "btn-sort"
              }`}
              onClick={() => handleSort("current_edu_course")}
            >
              Sort By Current Course{" "}
              {sort.direction === "asc" &&
              sort.field === "current_edu_course" ? (
                <FontAwesomeIcon icon={faArrowDown} />
              ) : sort.direction === "desc" &&
                sort.field === "current_edu_course" ? (
                <FontAwesomeIcon icon={faArrowUp} />
              ) : (
                ""
              )}{" "}
            </button>
          </div>
          {currentData && currentData.length !== 0 ? (
            <EducationDetail
              currentData={currentData}
              utMemeber={utMemeber}
              handleDataRefresh={handleDataRefresh}
            />
          ) : currentData && currentData.length === 0 ? (
            <div className="loader-content">No data found ....</div>
          ) : (
            <div className="loader-content">
              <HashLoader color={color} size={78} />
            </div>
          )}
        </Col>
      </Row>
    </>
  );
}
